































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { getFirstAndEndDay, getSelectMonths, getSelectYears, overPeriodYear } from '@/utils/dateFormat';
import SelectBox from '@/components/common/SelectBox.vue';
import SearchButton from '@/components/searchForm/SearchButton.vue';
import { OptionData } from '@/helpers/type';
import { getSmsHistoryInitQuery } from '@/const/contents/sms';
import { isEmpty, omit } from 'underscore';
import { getCurrentMallNo } from '@/utils/mall';
import moment from 'moment';
import { SmsGodoSearchType } from 'ncp-api-supporter';
import { isValidate } from '@/utils/validate';

@Component({
  components: { SearchButton, SelectBox },
})
export default class SmsHistorySearchForm extends Vue {
  private queryParams = getSmsHistoryInitQuery(getCurrentMallNo(this));
  // 발송요청일시
  private selectYear = new Date().getFullYear();
  private selectMonth = new Date().getMonth() + 1;
  private readonly yearList = getSelectYears(this.$t('YEAR').toString());
  private readonly monthList = getSelectMonths(this.$t('MONTH').toString());
  // 검색어
  private readonly searchTypeList: OptionData<SmsGodoSearchType>[] = [
    { value: 'MSG', name: 'MEMBER.SMS.CONTENT' },
    { value: 'TOPHONE', name: 'MEMBER.SMS_RESERVATION.RECIPIENT_NO' },
  ];
  // 발송상태
  private readonly statusTypeList: OptionData<string>[] = [
    { value: '', name: 'MEMBER.SMS_HISTORY.ALL' },
    { value: 'success', name: 'MEMBER.SMS_HISTORY.SUCCESS' },
    { value: 'fail', name: 'MEMBER.SMS_HISTORY.FAIL' },
  ];

  private changeSelectDate() {
    const { startYmd, endYmd } = getFirstAndEndDay(this.selectYear, this.selectMonth);

    this.queryParams.startDate = startYmd;
    this.queryParams.endDate = endYmd;
  }

  private validateQuery(): boolean {
    return isValidate(!overPeriodYear(moment(this.queryParams.startDate)), this.$t('MEMBER.KAKAO.ALERT_MAX_DATE'));
  }

  private sendQueryUrl(): void {
    (this.$refs.searchButton as SearchButton).sendQueryUrl();
  }

  @Watch('$route.query')
  private resetValue() {
    if (!isEmpty(omit(this.$route.query, 'mallNo'))) return;
    this.queryParams = getSmsHistoryInitQuery(getCurrentMallNo(this));
    this.queryParams.mallNo = getCurrentMallNo(this);
    this.selectYear = moment(this.queryParams.startDate)
      .toDate()
      .getFullYear();
    this.selectMonth =
      moment(this.queryParams.startDate)
        .toDate()
        .getMonth() + 1;
  }
}
